import React from 'react';
import styles from './Payments.module.css';
import useScrollReveal from './hooks/useScrollReveal';
import Header from './Section/Header';
import HowItWorks from './Section/HowItWorks';
import PaymentMethods from './Section/PaymentMethods';
import FeatureBlocks from './Section/FeatureBlocks';
import Capabilities from './Section/Capabilities';
import Faq from './Section/Faq';
import CallToAction from './Section/CallToAction';

const Payments = () => {
  useScrollReveal('[data-sr]');

  return (
    <div className={styles.page}>
      <Header />
      <HowItWorks />
      <PaymentMethods />
      <FeatureBlocks />
      <Capabilities />
      <Faq />
      <CallToAction />
    </div>
  );
};

export default Payments;
